import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../../../../webcommon/common/actionbutton/ActionButton';
import { noop } from 'lodash';
import defaultStyles from './DeleteRowModal.module.scss';
import actionButtonStyles from './ActionButtonOverride.module.scss';

const DeleteRow = props => (
    <div className={ props.styles.deleteRowWrapper }>
        <div className={ props.styles.rowToDelete }>
            Delete {props.rowToDelete}?
        </div>
        <div className={ props.styles.smallDeleteText }>
            Caution: This will permanently remove the template
        </div>
        <div className={ props.styles.deleteButton }>
            <ActionButton
                invertedAccent
                onClick={ props.deleteRow }
                styles={ actionButtonStyles }
            >
                Yes, Delete
            </ActionButton>
        </div>
        <div className={ props.styles.cancelButton }>
            <ActionButton
                accent
                onClick={ props.cancelDelete }
            >
                Cancel
            </ActionButton>
        </div>
    </div>
);

DeleteRow.propTypes = {
    cancelDelete: PropTypes.func,
    deleteRow: PropTypes.func,
    rowToDelete: PropTypes.string,
    styles: PropTypes.objectOf(PropTypes.string)
};

DeleteRow.defaultProps = {
    cancelDelete: noop,
    deleteRow: noop,
    rowToDelete: '',
    styles: defaultStyles
};

export default DeleteRow;
